import React from 'react';
import { RequiredIndicator } from '../RequiredIndicator';

interface FormInputProps {
    label: string;
    name: string;
    value: string | number;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    type?: 'text' | 'number' | 'email' | 'password';
    placeholder?: string;
    required?: boolean;
    className?: string;
    disabled?: boolean;
    error?: string;
    showRequiredIndicators?: boolean;
    dataTestId?: string;
}

const FormInput: React.FC<FormInputProps> = ({
    label,
    name,
    value,
    onChange,
    type = 'text',
    placeholder,
    required = false,
    className = '',
    disabled = false,
    error,
    showRequiredIndicators = false,
    dataTestId
}) => {
    const finalRequired = required || showRequiredIndicators;
    const id = name;

    return (
        <div className={className}>
            <label htmlFor={id} className="block text-sm font-medium text-gray-700">
                {label} {showRequiredIndicators && <RequiredIndicator />}
            </label>
            <div className="mt-1">
                <input
                    type={type}
                    name={name}
                    id={id}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    required={finalRequired}
                    disabled={disabled}
                    data-testid={dataTestId}
                    className={`shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md ${error ? 'border-red-500' : ''}`}
                />
                {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
            </div>
        </div>
    );
};

export default FormInput; 